<template>
  <div class="menu-toggler-container">
    <div class="menu-toggler" @click="toggleShowMenu">
      <div class="menu-icon" :class="togglerIcon"></div>
    </div>

    <div class="menu-container" v-if="showMenu">
      <div class="items">
        <div class="router-link-container">
          <router-link :to="{ name: 'TheTeam' }">
            {{ $t(`home.header.links[0]`) }}
          </router-link>
        </div>
        <div class="router-link-container">
          <router-link :to="{ name: 'AboutIizenglish' }">
            {{ $t(`home.header.links[1]`) }}
          </router-link>
        </div>
        <div class="router-link-container">
          <router-link :to="{ name: 'BlogPostsAboutUs' }">
            {{ $t(`home.header.links[2]`) }}
          </router-link>
        </div>
        <div class="router-link-container">
          <router-link :to="{ name: 'ContactUs' }">
            {{ $t(`home.header.links[3]`) }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Menu displayed on mobile in static pages
 */
export default {
  name: "StaticPagesMenuToggler",
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    toggleShowMenu() {
      this.showMenu = !this.showMenu;
    },
  },
  computed: {
    togglerIcon() {
      return this.showMenu ? "fas fa-times" : "fas fa-bars";
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-toggler-container {
  position: relative;

  .menu-toggler {
    width: 28px;

    .menu-icon {
      font-size: 2em;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .menu-container {
    background-color: $primaryColor;
    color: white;
    position: absolute;
    right: 0px;
    top: 45px;
    width: 300px;
    border-radius: 5px;
    z-index: 100;

    @media (max-width: 576px) {
      width: 250px;
    }

    .items {
      display: flex;
      flex-direction: column;
      font-weight: bold;
      margin: 20px 0px 20px 0px;

      .router-link-container {
        min-height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;

        a {
          color: inherit;
          text-decoration: none;

          &:hover {
            cursor: pointer;
            color: $secondaryColor;
          }
        }
      }
    }
  }
}
</style>
